
import { defineComponent } from "vue";

export default defineComponent({
	name: "Bar",
	props: {
		current: {
			type: Number,
			required: true,
		},
		max: {
			type: Number,
			required: true,
		},
	},
	computed: {
		percent() {
			return (this.current / this.max) * 100;
		},
	},
});
